import {vpost} from "@/util/post";

export const miuTag = {
    save(id, name, useFor, required, multiple, main) {
        let dto = {
            id,
            name,
            useFor,
            required,
            multiple,
            main
        };

        return vpost("/adminMiuTag/save", dto);
    },

    groupInfo(id) {
        return vpost("/adminMiuTag/getGroupVO?id=" + id);
    },

    list(type = null) {
        let dto = {
            type
        }

        return vpost("/adminMiuTag/list", dto);
    },

    insertTag(groupId, tagName) {
        let dto = {
            groupId,
            tagName
        }

        return vpost("/adminMiuTag/insertTag", dto);
    },

    deleteTag(id) {
        return vpost("/adminMiuTag/deleteTag?id=" + id);
    },


}
